import React, { useState } from 'react';
import { useSettings } from '../../../contexts/SettingsContext';

const VisualTab = () => {
  const { settings, updateSettings } = useSettings();
  const [message, setMessage] = useState('');

  const handleChange = async (field, value) => {
    try {
      await updateSettings({ [field]: value });
      setMessage('Settings updated!');
      setTimeout(() => setMessage(''), 2000);
    } catch (err) {
      setMessage('Update failed');
    }
  };

  if (!settings) return <div>Loading...</div>;

  return (
    <div>
      <div className="tab-section">
        <h3 className="section-title">Colors</h3>
        <p className="section-description">
          Customize display colors
        </p>

        <div className="form-row">
          <div className="form-group">
            <label>Background Color</label>
            <input
              type="color"
              value={settings.background_color}
              onChange={(e) => handleChange('background_color', e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>Card Color</label>
            <input
              type="color"
              value={settings.card_color}
              onChange={(e) => handleChange('card_color', e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>Number Color</label>
            <input
              type="color"
              value={settings.text_color}
              onChange={(e) => handleChange('text_color', e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>Split Line Color</label>
            <input
              type="color"
              value={settings.split_line_color}
              onChange={(e) => handleChange('split_line_color', e.target.value)}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Label Color</label>
            <input
              type="color"
              value={settings.label_color || '#e8dcc4'}
              onChange={(e) => handleChange('label_color', e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>Logo Color (deeptho)</label>
            <input
              type="color"
              value={settings.logo_color || '#e8dcc4'}
              onChange={(e) => handleChange('logo_color', e.target.value)}
            />
          </div>
        </div>
      </div>

      {message && <div className="success-message">{message}</div>}
    </div>
  );
};

export default VisualTab;